module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloud-wind-4cb78c8c14b64a1bb0d4406151e31cb8.svg";